import { create } from "zustand";
import type { UsageUpdateMessage } from "@/types";

interface UsageState {
  messagesUsedToday: number;
  messagesLimitToday: number;
  messagesRemainingToday: number;
  lmCallsUsedMonth: number;
  lmCallsLimitMonth: number;
  lmCallsRemainingMonth: number;
  updateUsage: (data: UsageUpdateMessage) => void;
  reset: () => void;
}

export const useUsageStore = create<UsageState>((set) => ({
  messagesUsedToday: 0,
  messagesLimitToday: 0,
  messagesRemainingToday: 0,
  lmCallsUsedMonth: 0,
  lmCallsLimitMonth: 0,
  lmCallsRemainingMonth: 0,

  updateUsage: (data) =>
    set({
      messagesUsedToday: data.messages_used_today,
      messagesLimitToday: data.messages_limit_today,
      messagesRemainingToday: data.messages_remaining_today,
      lmCallsUsedMonth: data.lm_calls_used_month,
      lmCallsLimitMonth: data.lm_calls_limit_month,
      lmCallsRemainingMonth: data.lm_calls_remaining_month,
    }),

  reset: () =>
    set({
      messagesUsedToday: 0,
      messagesLimitToday: 0,
      messagesRemainingToday: 0,
      lmCallsUsedMonth: 0,
      lmCallsLimitMonth: 0,
      lmCallsRemainingMonth: 0,
    }),
}));
